import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./PublicPage.css";

export default function TournamentTableView() {
  const { cardroom, id } = useParams();
  const token = localStorage.getItem("token");

  const [tournament, setTournament] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    const load = async () => {
      try {
        const { data } = await axios.get(`/${cardroom}/api/tournaments/${id}`);
        setTournament(data);
      } catch (err) {
        console.error("Load error", err);
      } finally {
        setLoading(false);
      }
    };

    load();
    const interval = setInterval(load, 5000);
    return () => clearInterval(interval);
  }, [token, id, cardroom]);

  if (loading || !tournament) {
    return (
      <div className="tournament-tv tournament-tv--loading">
        <div className="tournament-tv__spinner" />
      </div>
    );
  }

  const tables = tournament.tables || [];
  const allPlayers = tournament.players || [];
  const activePlayers = allPlayers.filter((p) => p.status === "playing");
  const totalTables = tables.length;
  const cols = Math.min(totalTables, 4);
  const isFinalTable = totalTables === 1;

  return (
    <div className="tournament-tv">
      <div className="tournament-tv__header">
        <p className="tournament-tv__eyebrow">
          {isFinalTable ? "Final Table" : "Seating Chart"}
        </p>
        <h1 className="tournament-tv__title">{tournament.name}</h1>
        {!isFinalTable && (
          <div className="tournament-tv__meta">
            <span>{activePlayers.length} players active</span>
            <span>{totalTables} tables</span>
          </div>
        )}
      </div>

      {tables.length === 0 ? (
        <div className="tournament-tv__empty">No tables created yet</div>
      ) : (
        <div
          className={`tournament-tv__grid${isFinalTable ? " tournament-tv__grid--final" : ""}`}
          style={{ "--tournament-table-columns": cols }}
        >
          {tables.map((table) => {
            const tablePlayers = activePlayers.filter((p) => p.table_id === table.id);
            const seats = Array.from({ length: 10 }, (_, i) => i + 1);

            return (
              <div
                key={table.id}
                className={`tournament-tv__table${isFinalTable ? " tournament-tv__table--final" : ""}`}
              >
                <div className="tournament-tv__table-header">
                  <span className="tournament-tv__table-name">
                    {table.name || `Table ${table.table_number}`}
                  </span>
                  <span className="tournament-tv__player-count">{tablePlayers.length}/10</span>
                </div>

                <div className="tournament-tv__seats">
                  {seats.map((seatNumber) => {
                    const seatedPlayer = tablePlayers.find((p) => p.seat_number === seatNumber);

                    return (
                      <div
                        key={seatNumber}
                        className={`tournament-tv__seat${seatedPlayer ? " is-occupied" : " is-empty"}`}
                      >
                        <span className="tournament-tv__seat-number">{seatNumber}</span>
                        <span className="tournament-tv__seat-name">
                          {seatedPlayer ? seatedPlayer.name : "-"}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
